import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { TranslateService } from '@ngx-translate/core';

export enum ResourceType {
  TRANSACTIONS = 'transactions',
  COMMISSIONS = 'commissions',
}

interface PublicLink {
  publicLinkId: number;
  url: string;
  uri: string;
  resourceType: ResourceType;
  createdAt: string;
  updatedAt: string;
  expiresAt: string;
}

interface PublicLinksResponse {
  records: PublicLink[];
}

@Component({
  selector: 'ew-share-public-link',
  templateUrl: './share-public-link.component.html',
  styleUrls: ['./share-public-link.component.scss'],
})
export class SharePublicLinkComponent {
  publicLinks: PublicLink[] = [];

  constructor(
    private API: ApiService,
    private TRANSLATE: TranslateService,
    @Inject(MAT_DIALOG_DATA)
    private data: { id: number; resourceType: ResourceType | string },
  ) {
    this.getPublicLinks();
  }

  /**
   * get public links
   * @author Martin Batun Tec.
   */
  getPublicLinks(): void {
    const endpoint = this.data.resourceType === ResourceType.COMMISSIONS
      ? `public-links/invoices/${this.data.id}`
      : `public-links/transactions/${this.data.id}`;

    this.API.get<PublicLinksResponse>(endpoint).subscribe({
      next: ({ records }) => {
        this.publicLinks = records.map(link => ({
          ...link,
          url: this.buildFullUrl(link)
        }));
      },
      error: (error) => {
        console.error('Error fetching public link:', error);
      },
    });
  }

  /**
   * generete a public link
   * @author Martin Batun Tec.
   */
  generatePublicLink(): void {
    this.API.post(`public-links`, {
      resourceType: this.data.resourceType,
      id: this.data.id,
    }).subscribe({
      next: (data: any) => {
        const newLink = {
          ...data.record,
          url: this.buildFullUrl(data.record)
        };
        this.publicLinks.push(newLink);
      },
      error: (error) => {
        console.error('Error generate public link:', error);
      },
    });
  }

  /**
   * Build full URL based on resource type
   * @param link PublicLink object
   * @returns Complete URL string
   */
  private buildFullUrl(link: PublicLink): string {
    return link.url
  }

  /**
   * get public link
   * @author Martin Batun Tec.
   */
  onCopied(): void {
    this.API.alertService.success(this.TRANSLATE.instant('alert:linkCopied'));
  }
}
